import React, { Component } from "react";
import { FormPasswordForgotten } from "../../components";
import { FormPasswordChange } from "../../components";
import "./styles.css";
import { from } from "rxjs";

class PasswordForgotten extends Component {
  render() {
    return (
      <div className="password-forgotten">
        <div className="content">

          <div className="content-box">

            <div className="how-thrive"><img src="/imgs/how-thrive.png" alt="How Thrive" /></div>
            <h1>Забравена парола?</h1>
            <p>Въведи имейл адреса, свързан с акаунта ти.</p>
            <FormPasswordForgotten />
            {/* <FormPasswordChange /> */}


          </div>
        </div>

        <div className="bg-1" />
        <div className="bg-2" />
      </div>
    );
  }
}

export default PasswordForgotten;



// WEBPACK FOOTER //
// ./src/screens/PasswordForgotten/PasswordForgotten.js